import { render, staticRenderFns } from "./PreCounsellingv1.vue?vue&type=template&id=10b1967c"
import script from "./PreCounsellingv1.vue?vue&type=script&lang=js"
export * from "./PreCounsellingv1.vue?vue&type=script&lang=js"
import style0 from "./PreCounsellingv1.vue?vue&type=style&index=0&id=10b1967c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports